enum Types {
  GET_ENVIRONMENT_MAINTENANCE_REQUEST = 'GET_ENVIRONMENT_MAINTENANCE_REQUEST',
  GET_ENVIRONMENT_MAINTENANCE_FULFILLED = 'GET_ENVIRONMENT_MAINTENANCE_FULFILLED',
  GET_ENVIRONMENT_MAINTENANCE_REJECTED = 'GET_ENVIRONMENT_MAINTENANCE_REJECTED',

  GET_CLIENT_MAINTENANCE_REQUEST = 'GET_CLIENT_MAINTENANCE_REQUEST',
  GET_CLIENT_MAINTENANCE_FULFILLED = 'GET_CLIENT_MAINTENANCE_FULFILLED',
  GET_CLIENT_MAINTENANCE_REJECTED = 'GET_CLIENT_MAINTENANCE_REJECTED',

  SET_ENVIRONMENT_MAINTENANCE_REQUEST = 'SET_ENVIRONMENT_MAINTENANCE_REQUEST',
  SET_ENVIRONMENT_MAINTENANCE_FULFILLED = 'SET_ENVIRONMENT_MAINTENANCE_FULFILLED',
  SET_ENVIRONMENT_MAINTENANCE_REJECTED = 'SET_ENVIRONMENT_MAINTENANCE_REJECTED',

  SET_CLIENT_MAINTENANCE_REQUEST = 'SET_CLIENT_MAINTENANCE_REQUEST',
  SET_CLIENT_MAINTENANCE_FULFILLED = 'SET_CLIENT_MAINTENANCE_FULFILLED',
  SET_CLIENT_MAINTENANCE_REJECTED = 'SET_CLIENT_MAINTENANCE_REJECTED',

  GET_ENVIRONMENT_MAINTENANCE_HISTORY_REQUEST = 'GET_ENVIRONMENT_MAINTENANCE_HISTORY_REQUEST',
  GET_ENVIRONMENT_MAINTENANCE_HISTORY_FULFILLED = 'GET_ENVIRONMENT_MAINTENANCE_HISTORY_FULFILLED',
  GET_ENVIRONMENT_MAINTENANCE_HISTORY_REJECTED = 'GET_ENVIRONMENT_MAINTENANCE_HISTORY_REJECTED',

  GET_CLIENT_MAINTENANCE_HISTORY_REQUEST = 'GET_CLIENT_MAINTENANCE_HISTORY_REQUEST',
  GET_CLIENT_MAINTENANCE_HISTORY_FULFILLED = 'GET_CLIENT_MAINTENANCE_HISTORY_FULFILLED',
  GET_CLIENT_MAINTENANCE_HISTORY_REJECTED = 'GET_CLIENT_MAINTENANCE_HISTORY_REJECTED',

  RETRIEVE_ENVIRONMENT_MAINTENANCE_HISTORY_REQUEST = 'RETRIEVE_ENVIRONMENT_MAINTENANCE_HISTORY_REQUEST',
  RETRIEVE_ENVIRONMENT_MAINTENANCE_HISTORY_FULFILLED = 'RETRIEVE_ENVIRONMENT_MAINTENANCE_HISTORY_FULFILLED',
  RETRIEVE_ENVIRONMENT_MAINTENANCE_HISTORY_REJECTED = 'RETRIEVE_ENVIRONMENT_MAINTENANCE_HISTORY_REJECTED',

  RETRIEVE_CLIENT_MAINTENANCE_HISTORY_REQUEST = 'RETRIEVE_CLIENT_MAINTENANCE_HISTORY_REQUEST',
  RETRIEVE_CLIENT_MAINTENANCE_HISTORY_FULFILLED = 'RETRIEVE_CLIENT_MAINTENANCE_HISTORY_FULFILLED',
  RETRIEVE_CLIENT_MAINTENANCE_HISTORY_REJECTED = 'RETRIEVE_CLIENT_MAINTENANCE_HISTORY_REJECTED',
}

export default Types;
